var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-btn",class:[{ active: _vm.active }, { vertical: _vm.vertical }]},[(_vm.icon)?_c('span',{staticClass:"icon-menu"},[_c('Icon',{attrs:{"type":_vm.icon}})],1):_vm._e(),(_vm.img)?_c('img',{staticClass:"icon-img",attrs:{"src":_vm.img,"alt":""}}):_vm._e(),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }